import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCheck } from '@fortawesome/free-solid-svg-icons';
import './LanguageSwitcher.css';

const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' }
];

const LanguageSwitcher = ({ variant = 'default' }) => {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  const current = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  return (
    <div className={`lang-switcher lang-switcher--${variant}`} ref={ref}>
      <button
        type="button"
        className="lang-switcher__trigger"
        onClick={() => setOpen(!open)}
        aria-label="Change language"
        aria-expanded={open}
      >
        <span className="lang-switcher__flag">{current.flag}</span>
        <span className="lang-switcher__code">{current.code.toUpperCase()}</span>
        <FontAwesomeIcon icon={faChevronDown} className="lang-switcher__arrow" />
      </button>
      {open && (
        <ul className="lang-switcher__menu" role="menu">
          {LANGUAGES.map(lang => (
            <li key={lang.code} role="none">
              <button
                type="button"
                role="menuitem"
                className={`lang-switcher__option ${language === lang.code ? 'lang-switcher__option--active' : ''}`}
                onClick={() => { setLanguage(lang.code); setOpen(false); }}
              >
                <span className="lang-switcher__flag">{lang.flag}</span>
                <span>{lang.label}</span>
                {language === lang.code && <FontAwesomeIcon icon={faCheck} className="lang-switcher__check" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
